export default { version: '2.10.0' };
